// src/pages/admin/invoices/FancyArabicLabel.jsx
export default function FancyArabicLabel({
  text,
  width = 100, // عدّل العرض حسب الحاجة
  rotate = -12, // ميلان لأعلى يمين
}) {
  // لو النص undefined/null/"" أو مسافات فقط -> نرجّع الاسم الافتراضي
  const label = (text ?? "").toString().trim() || "يورنيم";

  const height = 95; // ارتفاع SVG
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 520 220"
      className="absolute top-[198px] left-[165px]"
      style={{ transform: `rotate(${rotate}deg)` }}
      aria-label={label}
    >
      <defs>
        {/* تدرّج برتقالي داخلي */}
        <linearGradient id="fillGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFB24A" />
          <stop offset="60%" stopColor="#FF8C1A" />
          <stop offset="100%" stopColor="#FF6A00" />
        </linearGradient>

        {/* ظل ناعم */}
        <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="4" dy="6" stdDeviation="4" floodOpacity="0.35" />
        </filter>
      </defs>

      <g filter="url(#softShadow)" transform="translate(260,115) skewY(-4)">
        {/* 1) الحدّ الخارجي الغامق (سُمك كبير) */}
        <text
          x="0"
          y="0"
          textAnchor="middle"
          fontFamily='"Hacen Maghreb","Tajawal",system-ui,sans-serif'
          fontWeight="800"
          fontSize="120"
          stroke="#7a3d14"
          strokeWidth="18"
          strokeLinejoin="round"
          paintOrder="stroke"
          fill="none"
        >
          {label}
        </text>

        {/* 2) حدّ داخلي أفتح (لمسة 3D خفيفة) */}
        <text
          x="0"
          y="0"
          textAnchor="middle"
          fontFamily='"Hacen Maghreb","Tajawal",system-ui,sans-serif'
          fontWeight="800"
          fontSize="120"
          stroke="#d89b62"
          strokeWidth="8"
          strokeLinejoin="round"
          paintOrder="stroke"
          fill="none"
        >
          {label}
        </text>

        {/* 3) تعبئة بتدرّج برتقالي */}
        <text
          x="0"
          y="0"
          textAnchor="middle"
          fontFamily='"Hacen Maghreb","Tajawal",system-ui,sans-serif'
          fontWeight="800"
          fontSize="120"
          fill="url(#fillGrad)"
          style={{ letterSpacing: "-2px" }}
        >
          {label}
        </text>
      </g>
    </svg>
  );
}
